<template>
  <div class="lego-sample-box">
    <div class="lego-sample-box__title" @click="collapseAll" :class="titleClass">{{title}}</div>
    <template v-if="!isAllCollapsed">
      <div v-show="isShowDescription" class="lego-sample-box__description">
        <slot name="description" />
        <slot name="desc" />
      </div>
      <div class="lego-sample-box__sample">
        <slot/>
      </div>
      <div class="lego-sample-box__fold-toggle" @click="toggleCode">
        {{ foldToggle?'Collapse source':'Expand source' }}
      </div>
      <div v-show="foldToggle" class="lego-sample-box__code">
        <div v-show="template" class="lego-sample-box__code-block">
          <div class="lego-sample-box__title">{{templateTitle}}</div>
          <pre><code>{{template}}</code></pre>
        </div>
        <div v-show="script" class="lego-sample-box__code-block">
          <div class="lego-sample-box__title">{{scriptTitle}}</div>
          <pre><code>{{script}}</code></pre>
        </div>
        <div v-show="style" class="lego-sample-box__code-block">
          <div class="lego-sample-box__title">{{styleTitle}}</div>
          <pre><code>{{style}}</code></pre>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SuiShowcaseBox',
  props: {
    title: { type: String, default: '' },
    rawFile: { type: String, default: '' },
    collapsible: { type: Boolean, default: false }, // 전역으로 먹일라면 default:true;
  },
  data() {
    return {
      sampleTitle: '<Sample/>',
      templateTitle: '<Template/>',
      scriptTitle: '<Script/>',
      styleTitle: '<Style/>',
      foldToggle: false,
      isAllCollapsed: false,
      template: '',
      script: '',
      style: '',
    };
  },
  computed: {
    titleClass() {
      let clazz = [];
      if (this.collapsible) { clazz.push('lego-sample-box__title--collapsible'); }
      return clazz;
    },
    isShowDescription() {
      return this.$scopedSlots.description || this.$scopedSlots.desc;
    },
  },
  created() {
    this.parse();
  },
  methods: {
    toggleCode() {
      this.foldToggle = !this.foldToggle;
    },
    parse(raw = this.rawFile) {
      let splitArr = [];
      let template = '';
      let script = '';
      let style = '';
      splitArr = raw.split('\n<template>');
      if (splitArr.length === 2) {
        template = splitArr[0];
        raw = splitArr[1];
        template = template.slice(template.indexOf('<template'));
        template = template.slice(template.indexOf('>') + 1);
        while (/^\s*\n/.exec(template) !== null) {
          template = template.slice(template.indexOf('\n') + 1);
        }
        template = template.split('\n');
        while (template.every(v => /^[\s\t]/.exec(v))) {
          template = template.map(v => v.slice(1));
        }
        template = template.join('\n');
        // sample-tips 추가, template에서 제거함
        template = template.replace(/\s*<sui-showcase-tip>.*<\/sample-tip>/gi, '');
        this.template = template;
      }

      splitArr = raw.split('\n<script>');
      if (splitArr.length === 2) {
        script = splitArr[0];
        raw = splitArr[1];
        script = script.slice(script.indexOf('<script'));
        script = script.slice(script.indexOf('>') + 1);
        while (/^\s*\n/.exec(script) !== null) {
          script = script.slice(script.indexOf('\n') + 1);
        }
        script = script.split('\n');
        while (script.every(v => /^[\s\t]/.exec(v))) {
          script = script.map(v => v.slice(1));
        }
        script = script.join('\n');
        this.script = script;
      }

      splitArr = raw.split('\n<style>');
      if (splitArr.length === 2) {
        style = splitArr[0];
        raw = splitArr[1];
        style = style.slice(style.indexOf('<style'));
        style = style.slice(style.indexOf('>') + 1);
        while (/^\s*\n/.exec(style) !== null) {
          style = style.slice(style.indexOf('\n') + 1);
        }
        style = style.split('\n');
        while (style.every(v => /^[\s\t]/.exec(v))) {
          style = style.map(v => v.slice(1));
        }
        style = style.join('\n');
        this.style = style;
      }
    },
    collapseAll() {
      if (!this.collapsible) return;
      this.isAllCollapsed = !this.isAllCollapsed;
    },
  },
};
</script>


<style lang="scss">

.lego-sample-box {
    position: relative;width: 100%;padding: 10px;border-radius: 5px;
    background-color: #b6c3dd;
}
.lego-sample-box + .lego-sample-box {margin-top:20px;}
.lego-sample-box > .lego-sample-box__title {
    height: 24px;line-height: 24px;margin-bottom:0px;
    font-weight: bold;font-size: 16px;color: #333;
}

.lego-sample-box__code .lego-sample-box__title {
    display: inline-block;
    font-weight: bold;font-size: 14px;
    background: #464646;color: #FFF;
    border-top-right-radius: 30px;
    border-top-left-radius: 3px;
    padding: 6px 30px 5px 15px;
}

.lego-sample-box__title--collapsible {cursor:pointer;}
.lego-sample-box__title--collapsible:hover {color:#4d83bf;}
.lego-sample-box__description {
    padding: 5px 0;white-space: pre-line;color: #666;
    font-size:14px;font-weight:normal;
}
.lego-sample-box__sample {position: relative;padding: 10px;background-color: white;margin-top:10px;}
.lego-sample-box__fold-toggle {
    position: relative;margin-top:10px;width:100%;height: 30px;text-align: center;cursor: pointer;
    color: #333;background-color: #FFF;font-weight:bold;}
.lego-sample-box__fold-toggle:hover {color:#4d83bf}
.lego-sample-box__code {margin-top:10px;position: relative;}
.lego-sample-box__code-block {overflow: auto;}
.lego-sample-box__code-block + .lego-sample-box__code-block {margin-top: 10px;}
.lego-sample-box .tui-editor-contents > pre {margin: 0;padding: 10px;max-height: 300px;overflow: auto;}
/** sample-tips 추가, 코딱지 스타일 **/
.lego-sample-box .lego-sample-box__sample .sample-tip {font-size: 12px; margin:10px 0;}
.lego-sample-box .lego-sample-box__sample .sample-tip:first-child {margin-top:0;}
.lego-sample-box .lego-sample-box__sample .sample-tip+.sample-tip {margin-top:-7px;}
.lego-sample-box .lego-sample-box__sample .sample-tip > sub {color:#888;vertical-align: initial;font-size:inherit;margin-left:3px;}
.lego-sample-box .lego-sample-box__sample .sample-tip > sub:before {content:"("}
.lego-sample-box .lego-sample-box__sample .sample-tip > sub:after {content:")"}

.lego-sample-box__code {
  pre {border:1px solid #888;background-color: #efefef;overflow: auto;padding:12px 15px;}
  code {font-family: d2Coding, Consolas, dotum, "돋움", sans-serif;
    font-size: 14px;color:#444;line-height: 150%;}
}
  

</style>
